export const ERROR_MESSAGE =
  'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже';

export const TO_MATCH_SUB_MESSAGE =
  'Вы можете оформить 6 подписок, если Вам необходимо большее количество подписок, обращайтесь на sales@ab.ua.';

export const SUB_OPTIONS = [
  { key: 'every-hour', label: 'Получать письма каждый час' },
  { key: 'every-four-hours', label: 'Получать письма каждые 4 часа' },
  { key: 'daily', label: 'Получать письма раз в день' },
  { key: 'weekly', label: 'Получать письма раз в неделю' },
  { key: null, label: 'Не получать письма' },
];



// WEBPACK FOOTER //
// ./src/shared/constants/searchSubscriptions.js